import { supabase } from '../config/supabase';

const DEV = import.meta.env.DEV;

/**
 * Create a referral and get back the referral code.
 */
export async function createReferral(refereeEmail) {
  try {
    const { data, error } = await supabase.rpc('create_referral', {
      p_referee_email: refereeEmail,
    });
    if (error) throw error;
    // RPC returns table with single row { referral_code }
    return { code: data?.[0]?.referral_code || data?.referral_code || null, error: null };
  } catch (err) {
    if (DEV) console.error('[Referral] create failed:', err.message);
    return { code: null, error: err.message };
  }
}

/**
 * Get all referrals for the current user.
 */
export async function getMyReferrals() {
  try {
    const { data, error } = await supabase.rpc('get_my_referrals');
    if (error) throw error;
    return { referrals: data || [], error: null };
  } catch (err) {
    if (DEV) console.error('[Referral] fetch failed:', err.message);
    return { referrals: [], error: err.message };
  }
}

/**
 * Accept a referral by code. Returns the referrer's user ID for push notification.
 */
export async function acceptReferral(code) {
  try {
    const { data, error } = await supabase.rpc('accept_referral', { code });
    if (error) throw error;
    // RPC returns table with single row { referrer_id }
    const referrerId = data?.[0]?.referrer_id || data?.referrer_id || null;
    return { referrerId, error: null };
  } catch (err) {
    if (DEV) console.error('[Referral] accept failed:', err.message);
    return { referrerId: null, error: err.message };
  }
}

/**
 * Send the referral invite email via edge function.
 */
export async function sendReferralInvite(refereeEmail, referralCode, referrerName) {
  try {
    const { error } = await supabase.functions.invoke('send-referral-invite', {
      body: { referee_email: refereeEmail, referral_code: referralCode, referrer_name: referrerName },
    });
    if (error) throw error;
    return { sent: true, error: null };
  } catch (err) {
    if (DEV) console.error('[Referral] invite email failed:', err.message);
    return { sent: false, error: err.message };
  }
}

/**
 * Get bonus vehicle count for a user.
 */
export async function getBonusVehicles(userId) {
  try {
    const { data, error } = await supabase.rpc('get_bonus_vehicles', { uid: userId });
    if (error) throw error;
    return data || 0;
  } catch (err) {
    if (DEV) console.error('[Referral] bonus vehicles fetch failed:', err.message);
    return 0;
  }
}

/**
 * Send push notification to the referrer that their referral was accepted.
 */
export async function notifyReferralAccepted(referrerId) {
  try {
    await supabase.functions.invoke('send-push-notification', {
      body: { type: 'referral_accepted', user_id: referrerId },
    });
  } catch (err) {
    if (DEV) console.error('[Referral] push notification failed:', err.message);
  }
}
